import * as React from 'react'

type SelectMenuContextValue = {
  size: 'sm' | 'md' | 'lg'
  theme: 'white' | 'grey'
  state?: 'error'
}

export const SelectMenuContext = React.createContext<SelectMenuContextValue>({
  size: 'md',
  theme: 'grey'
})

export const useSelectMenuContext = () => React.useContext(SelectMenuContext)
